module.exports = __webpack_public_path__ + "img/answer-pin-active.fe13bfc7.svg";